import { useState, ChangeEvent } from "react";
import { Box, Paper } from "@mui/material";
import ChatInput from "./components/input";
import { styled } from "@mui/styles";
import ChatMessage from "./components/message";
import TextContainer from "../../components/Texts/TextContainer";

const Container = styled(Box)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  height: "100%",
});
const Chat = () => {
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState<string[]>(["", ""]);
  const handleMessageChange = (event: ChangeEvent<HTMLInputElement>) => {
    setMessage(event.target.value);
  };
  return (
    <Container>
      <Paper
        elevation={3}
        sx={{
          bgcolor: "primary.light",
          width: "100%",
          display: "flex",
          borderRadius: "15px",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Box width="100%" bgcolor="secondary.main" padding=".3rem 1rem">
          <TextContainer width="100%" justifyContent="right" fontFamily="'YekanBold !important'" color="primary.main">ticket title</TextContainer>
        </Box>
        <Box
          flexGrow={1}
          overflow="auto"
          px={2}
          width="100%"
          pt={2}
          sx={{
            "&::-webkit-scrollbar": {
              width: "0.4em",
            },
            "&::-webkit-scrollbar-track": {
              "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(0,0,0,.1)",
              outline: "1px solid slategrey",
            },
          }}
        >
          {messages?.map((id: any) => (
            //@ts-ignore  
            <ChatMessage
              // {...messages.entities[id]}
              key={id}
              isMyMessage={true}
            />
          ))}
        </Box>
        <ChatInput
          message={message}
          onMessageChange={handleMessageChange}
          onSendMessage={() => console.log("send")}
        />
      </Paper>
    </Container>
  );
};
export default Chat;
